<template>
  <div>
    <div v-if="initializing" class="text-center my-3">
      <font-awesome-icon spin icon="circle-notch" class="text-moremuted display-2"/>
    </div>

    <template v-else>
      <b-btn
        class="d-print-none float-left mb-3"
        :title="$t('shared.printThisPage')"
        @click="print"
      >
        <font-awesome-icon
          icon="print"
          class="align-middle"
          fixed-width
        />
      </b-btn>

      <table class="table table-sm table-bordered">
        <tbody>
          <tr class="text-center">
            <td colspan="12" class="bg-light font-weight-bold">
              گزارش قبض باسکول و صورت جلسه تحویل محصول
            </td>
          </tr>

          <tr>
            <td colspan="3" class="bg-light text-center">
              {{ $t('transports.buyerName') }}
            </td>

            <td colspan="3" class="bg-light text-center">
              شماره سفارش
            </td>

            <td colspan="3" class="bg-light text-center">
              شماره حواله تحویل
            </td>

            <td colspan="3" class="bg-light text-center">
              شماره مجوز شرکت حمل و نقل
            </td>
          </tr>

          <tr>
            <td colspan="3">
              {{ getUserDisplayName(transport.dealer) }}
            </td>

            <td colspan="3">
              {{ transport.stock.orderCode }}
            </td>

            <td colspan="3">
              {{ transport.deliveryNumber }}
            </td>

            <td colspan="3">
            </td>
          </tr>

          <tr class="text-center">
            <td colspan="6" class="bg-light">
              تاریخ مجوز شرکت حمل و نقل
            </td>

            <td colspan="6" class="bg-light">
              {{ $t('transports.productDescription') }}
            </td>
          </tr>

          <tr>
            <td colspan="6">
              از
              <date-display :value="transportLicense.validFrom" time class="mx-2" icon-class=""/>
              تا
              <date-display :value="transportLicense.validUntil" time class="mx-2" icon-class=""/>
            </td>

            <td colspan="6">
              {{ (transport.bundlesCount * transport.stock.bundleRate).toLocaleString() }}
              {{ transport.stock.model.product.type.unit.name }}
              {{ transport.stock.model.product.title }}
            </td>
          </tr>

          <tr class="text-center">
            <td colspan="12" class="bg-light">
              {{ $t('transports.weighingInfo') }}
            </td>
          </tr>

          <tr>
            <td colspan="3">
              {{ $t('transports.emptyWeight') }} :

              {{ model.emptyWeight && model.emptyWeight.toLocaleString() }}

              {{ transport.stock.model.product.type.unit.name }}
            </td>

            <td colspan="3">
              {{ $t('transports.weighbridgeReceipt') }} :

              {{ model.emptyWeighbridgeReceipt && model.emptyWeighbridgeReceipt.toLocaleString() }}
            </td>

            <td colspan="3">
              {{ $t('transports.date') }} :

              <date-display :value="model.emptyDate" class="mx-2" icon-class=""/>
            </td>

            <td colspan="3">
              {{ $t('transports.weighingHour') }} :

              {{ model.emptyWeighingHour.split(':')[0] }}:{{ model.emptyWeighingHour.split(':')[1] }}
            </td>
          </tr>

          <tr>
            <td colspan="3">
              {{ $t('transports.fullWeight') }} :

              {{ model.fullWeight && model.fullWeight.toLocaleString() }}

              {{ transport.stock.model.product.type.unit.name }}
            </td>

            <td colspan="3">
              {{ $t('transports.weighbridgeReceipt') }} :

              {{ model.fullWeighbridgeReceipt && model.fullWeighbridgeReceipt.toLocaleString() }}
            </td>

            <td colspan="3">
              {{ $t('transports.date') }} :

              <date-display :value="model.fullDate" class="mx-2" icon-class=""/>
            </td>

            <td colspan="3">
              {{ $t('transports.weighingHour') }} :

              {{ model.fullWeighingHour.split(':')[0] }}:{{ model.fullWeighingHour.split(':')[1] }}
            </td>
          </tr>

          <tr>
            <td colspan="4">
              {{ $t('transports.actualWeight') }} :

              {{ model.actualWeight && model.actualWeight.toLocaleString() }}

              {{ transport.stock.model.product.type.unit.name }}
            </td>

            <td colspan="4">
              به حروف :

              {{ model.actualWeight && model.actualWeight.toPersianLetter() }}
            </td>

            <td colspan="4">
              {{ $t('transports.bundleCount') }} :

              {{ model.bundleCount && model.bundleCount.toLocaleString()}}
            </td>
          </tr>

          <tr class="text-center">
            <td colspan="12" class="bg-light">
              {{ $t('transports.recipientInfo') }}
            </td>
          </tr>

          <tr>
            <td colspan="3">
              نام و نام خانوادگی راننده :

              {{ transportLicense.driverFirstName }} {{ transportLicense.driverLastName }}
            </td>

            <td colspan="3">
              کد ملی راننده :

              {{ transportLicense.driverNationalCode }}
            </td>

            <td colspan="3">
              موبایل راننده :

              {{ transportLicense.driverPhoneNumber }}
            </td>

            <td colspan="3">
              شماره هوشمند راننده :

              {{ transportLicense.driverSmartNumber }}
            </td>
          </tr>

          <tr>
            <td colspan="3">
              شماره گواهینامه :

              {{ transportLicense.driverLicenseNumber }}
            </td>

            <td colspan="3">
              محل صدور :

              {{ transportLicense.driverIssuePlace }}
            </td>

            <td colspan="3">
              شماره هوشمند وسیله :

              {{ transportLicense.vehicleSmartNumber }}
            </td>

            <td colspan="3">
              نام وسیله :

              {{ transportLicense.vehicleName }}
            </td>
          </tr>

          <tr>
            <td colspan="4">
              نام بارگیر :

              {{ transportLicense.trailerName }}
            </td>

            <td colspan="4">
              شماره انتظامی وسیله :

              {{ transportLicense.plateNumber }}
            </td>

            <td colspan="4">
              شماره انتظامی بارگیر :

              {{ transportLicense.plateCode }}
            </td>
          </tr>

          <tr class="text-center">
            <td colspan="12">
              {{ $t('transports.recipientDescription') }}
            </td>
          </tr>
        </tbody>
      </table>

      <div class="d-flex justify-content-end my-5">
        {{ $t('transports.recipientSignature') }}
      </div>

      <table v-if="transport.stock.inventory" class="table table-sm table-bordered">
        <tbody>
          <tr class="text-center">
            <td colspan="12" class="bg-light font-weight-bold">
              {{ $t('transports.deliveryInfo') }}
            </td>
          </tr>

          <tr>
            <td colspan="6">
              {{ $t('inventories.inventoryName') }} :

              {{ transport.stock.inventory.name }}
            </td>

            <td colspan="6">
              نام و نام خانوادگی متصدی انبار :

              {{ transport.stock.inventory.operatorName }}
            </td>
          </tr>
        </tbody>
      </table>

      <div class="d-flex justify-content-end my-5">
        {{ $t('transports.inventorySignature') }}
      </div>

      <table v-if="transport.courierId" class="table table-sm table-bordered">
        <tbody>
          <tr class="text-center">
            <td colspan="12" class="bg-light font-weight-bold">
              {{ $t('transports.unloadPlace') }}
            </td>
          </tr>

          <tr>
            <td colspan="2">
              {{ $t('transports.province') }} :

              <template v-if="transport.unloadProvince">
                {{ transport.unloadProvince.name }}
              </template>
            </td>

            <td colspan="2">
              {{ $t('transports.city') }} :

              <template v-if="transport.unloadCity">
                {{ transport.unloadCity.name }}
              </template>
            </td>

            <td colspan="2">
              {{ $t('transports.zipCode') }} :

              {{ transport.unloadZipCode }}
            </td>

            <td colspan="6" style="width:50%">
              {{ $t('transports.address') }} :

              {{ transport.unloadAddress }}
            </td>
          </tr>

          <tr>
            <td colspan="2">
              {{ $t('transports.unloadTime') }} :

              {{ transport.unloadTimeFrom.split(':')[0] }} {{ $t('products.to') }} {{ transport.unloadTimeTo.split(':')[0] }}
            </td>

            <td colspan="3">
              {{ $t('transports.recipientName') }} :

              {{ transport.recipientName }}
            </td>

            <td colspan="3">
              {{ $t('transports.recipientNationalCode') }} :

              {{ transport.recipientNationalCode }}
            </td>

            <td colspan="2">
              {{ $t('transports.recipientPhoneNumber') }} :

              {{ transport.recipientPhoneNumber }}
            </td>

            <td colspan="2">
              {{ $t('transports.recipientCellNumber') }} :

              {{ transport.recipientCellNumber }}
            </td>
          </tr>
        </tbody>
      </table>
    </template>
  </div>
</template>

<script>
import { DateDisplay } from '@/components/shared'

export default {
  name: 'LicenseRecordPrint',
  components: {
    DateDisplay
  },
  props: ['transportId', 'licenseId'],
  data () {
    return {
      initializing: true,
      model: null,
      transport: null,
      transportLicense: null
    }
  },
  mounted () {
    Promise.all([
      this.getModel(),
      this.getTransport(),
      this.getTransportLicense()
    ])
    .then(() => {
      this.initializing = false
    })
  },
  methods: {
    getModel () {
      return this.$api.transports.getRecord(this.transportId, this.licenseId)
      .then(res => {
        this.model = res

        if (!this.model)
          this.$router.push('/transports')
      })
      .catch(err => {
        this.$showError(this.$getLocaleErrorMessage(err, 'transports'))
      })
    },
    getTransport () {
      return this.$api.transports.getById(this.transportId, { include: 'Courier' })
      .then(res => {
        this.transport = res
      })
      .catch(err => {
        this.$showError(this.$getLocaleErrorMessage(err, 'transports'))
      })
    },
    getTransportLicense () {
      return this.$api.transports.getLicenseById(this.transportId, this.licenseId)
      .then(res => {
        this.transportLicense = res
      })
      .catch(err => {
        this.$showError(this.$getLocaleErrorMessage(err, 'transports'))
      })
    },
    getUserDisplayName (user) {
      return this.$api.account.getUserDisplayName(user)
    },
    print () {
      window.print()
    }
  }
}
</script>
